
import { Component, Vue } from "vue-property-decorator";
//import ReklamacjaVue from "./Reklamacja.vue";
import FinderVue from "@/finder/Finder.vue";

import { IReklamacja, Dict } from "@/reklamacja/IReklamacja";

import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import  ButtonVue from "@/lib/Button.vue";
import UploaderVue from "@/uploader/Uploader.vue";

import { ReklamacjaSvc } from "@/reklamacja/ReklamacjaSvc";
import { Next, Route } from 'vue-router';
import { DateString } from "@/DateString";

@Component({ async beforeRouteEnter(to: Route, from: Route, next: Next<ReklamacjaVue>) {
            console.log("********************* beforeRouteEnter:", to.path, to.params.reklamacja_id )
            next((vm: ReklamacjaVue) => { vm.id = to.params.reklamacja_id  });
        },
        components: { ButtonVue, FinderVue} 
        })

export default class ReklamacjaVue extends Vue {

  id:string="";
  _id:string="";
  reklamacja: IReklamacja|undefined=undefined;
  key=0;
  new_labels=0;
  reklamacjaSvc=new ReklamacjaSvc()
  dict=new Dict()
  zlecenie:any
  powody: string[] = Dict.powody;
  przyczyny: string[] = Dict.przyczyny;
  rodzaje: string[] = Dict.rodzaje;
  zwrot_etykiet: string[] = Dict.zwrot_etykiet;
  
  async chg() {
    if (!this.reklamacja) return;
    console.log("reklamacja:chg")
    const reklamacja =  await this.reklamacjaSvc.update(this.reklamacja)
    if (reklamacja && reklamacja.version) {
      this.reklamacja.version = reklamacja.version;
    }
    this.key++;
  }


  async chgk() {
    if (!this.reklamacja) return;
    const r=this.reklamacja;
/*
    ilosc_zlecenie:Number;
    ilosc_reklamowana:Number
    ilosc_wadliwych:Number
    ilosc_wadliwych_uznana:Number

    wartosc_1K:Number
    wartosc_zlecenie:Number
    wartosc_reklamowana:Number
    wartosc_wadliwych:Number
    wartosc_wadliwych_uznana:Number

    koszt_transportu:number
    koszty_inne:number
    koszty_inne_opis:string;
    koszt_reklamacji:Number;
*/
    r.wartosc_zlecenie = Math.ceil(r.ilosc_zlecenie / 1000 * r.wartosc_1K );

    const pr = r.ilosc_reklamowana / r.ilosc_zlecenie;
    r.wartosc_reklamowana = Math.ceil( r.wartosc_zlecenie * pr )

    const pw = r.ilosc_wadliwych / r.ilosc_zlecenie;
    r.wartosc_wadliwych = Math.ceil( r.wartosc_zlecenie * pw )

    const pwu = r.ilosc_wadliwych_uznana / r.ilosc_zlecenie;
    r.wartosc_wadliwych_uznana = Math.ceil( r.wartosc_zlecenie * pwu )

    r.koszt_reklamacji = Math.ceil( r.wartosc_wadliwych_uznana + r.koszt_transportu + r.koszty_inne )

    this.chg()
  }

  async refresh() {

        console.log("refresh using id", this.id);
        const l = await this.reklamacjaSvc.find_by_id( this.id );
        console.log("************** found reklamacja",JSON.stringify(l))
        if (l) {
          this.reklamacja = l;
          this.key++;
        }
  }


  async del_reklamacja(l: IReklamacja) {
      if (confirm("Na pewno skasować reklamację "+l.idn+"?")) {
        const reklamacja = await this.reklamacjaSvc.delete(l);
      }
    }


    async mounted() {
      bus.register('zlecenie_selected', this.zlecenie_selected)
      bus.register('reklamacja_chg', this.chg)
      
      console.log('reklamacja mounted', this.id)
      await this.refresh();
    }

    async beforeDestroy() {
      bus.remove('zlecenie_selected', this.zlecenie_selected)
      bus.remove('reklamacja_chg', this.chg)
    }

  async zlecenie_selected(e:any) {
    if (!this.reklamacja) return;
    const zl = this.reklamacja.zlecenie
    zl.data.historia= await this.reklamacjaSvc.get_historia_zlecenia( zl.data.data_zlecenie_id );
    this.chg()
  }

  async add_comment(h:any) {
    if (!h.comments) h.comments=[]
    h.comments.push({date:new Date().toLocaleDateString(['de-DE'], {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',second: '2-digit' })
    , user:bus.get_user().data_username, text:""})
    console.log(JSON.stringify(h))
    this.chg()
  }

}
